<template>
	<section v-loading="loading" class="book-box" element-loading-text="加载中...">
		<div v-if="dataList.length > 0">
			<div class="booklist">
				<div v-for="(info, cidx) in dataList" :key="'for_book_' + info.id" class="infobox">
					<div class="txtheader">
						<div class="tags">
							<!-- {{ info.buyPaper }} --- {{  info.buyPdf}} -->
							<el-tag v-if="getLifeName(info.lifeId)" :type="getLifeTagType(info.lifeId)" style="border-radius: 20px; padding: 0 20px; border: none; height: 24px; line-height: 24px" effect="dark">
								{{ getLifeName(info.lifeId) }}
							</el-tag>
							<div v-if="info.standardIndustry.length > 0" class="tagbg tagblue">特种设备</div>
							<div v-if="getStandardTypeName(info.standardTypeId)" class="tagbg taggreen">{{ getStandardTypeName(info.standardTypeId) }}</div>
							<!-- <div v-if="info.lifeName" class="tagbg tagred">{{ info.lifeName }}</div> -->
							<div class="tagbg tagorange" v-if="info.buyPaper">{{ info.buyPaper ? '纸质版可购' : '' }}</div>
							<div class="tagbg tagorange" v-if="info.buyPdf">{{ info.buyPdf ? '电子版可购' : '' }}</div>
							<!-- <div  class="tagbg tagorange" v-if="info.buyJson ">{{ info.buyJson?'智能文档可购':'' }}</div> -->
							<div class="tagbg tagorange" v-if="info.isPdf !== 0">{{ info.pdfRead == 0 ? 'PDF 公开文件' : info.pdfRead == 1 ? 'PDF VIP阅读' : info.pdfRead == 2 ? 'PDF 购买后可阅读' : '' }}</div>
							<div class="tagbg tagorange" v-if="info.isJson !== 0">{{ info.jsonRead == 0 ? '智能文档 公开文件' : info.jsonRead == 1 ? '智能文档 VIP阅读' : info.jsonRead == 2 ? '智能文档 购买后可阅读' : '' }}</div>
							<div class="tagbg tagorange" v-if="info.isAi !== 0">{{ info.isAi ? 'AI 收录' : '' }}</div>

							<!-- <div v-if="info.lifeName" class="tagbg tagred">{{ info.lifeName }}</div> -->
							<!-- <div class="tag-right">
								<el-tag v-if="info.lifeName" :type="getLifeTagType(info.lifeName)" style="border-radius: 20px; padding: 0 20px; border: none; height: 24px; line-height: 24px" effect="dark">
									{{ info.lifeName }}
								</el-tag>
							</div> -->
						</div>
					</div>
					<div class="imgbox"></div>
					<div class="txtbox" @click="handleInfo(info)">
						<h3 class="title-row">
							<span class="booktitle-wrap">
								<span v-if="info.standardCode" class="booktitle" v-html="highlightText(info.standardCode + ' ' + info.standardName)"></span>
								<span v-else class="booktitle" v-html="highlightText(info.standardName)"></span>
							</span>
							<el-button type="primary" size="small" plain round @click.stop="handleInfo(info)">查看详情</el-button>
						</h3>
						<div class="contbox">
							<div class="leftbox">
								<div class="textouter" v-if="info.standardSummary" :title="info.standardSummary" v-html="highlightText(info.standardSummary)"></div>
								<div class="textouter" v-if="!info.standardSummary && info.standardScope" :title="info.standardScope" v-html="highlightText(info.standardScope)"></div>
							</div>
							<div class="rightbox" @click.stop>
								<el-button style="margin-left: 0" v-if="info.isJson !== 0" type="warning" size="small" plain round @click="handleSmartDoc(info)">智能文档阅读</el-button>
								<el-button style="margin-left: 0" v-if="canReadPdf(info)" type="warning" size="small" plain round @click="handleReadItem(info)">PDF文档阅读</el-button>
							</div>
						</div>
						<div class="product-list" v-if="showProduct && (info.paperStandardProduct && info.paperStandardProduct.length || info.digitStandardProduct && info.digitStandardProduct.length)">
							<el-divider content-position="left">商品信息</el-divider>
							<!-- 纸质版商品 -->
							<div v-for="(item, idx) in info.paperStandardProduct || []" :key="'paper_' + info.id + '_' + idx" class="product-item">
								<div class="product-info">
									<div class="product-name">
										<el-tag size="mini" type="primary" effect="plain" class="product-type-tag">纸质版</el-tag>
									</div>
									<div class="product-spu" v-if="item.prdSpuName" :title="item.prdSpuName">{{ formatProductName(item, info) }}</div>
									<div class="product-price">
										<span class="now-price">￥{{ displayPrice(item) }}</span>
										<span class="before-price" v-if="item.defaultPrice && displayPrice(item) < item.defaultPrice">￥{{ item.defaultPrice }}</span>
										<el-tag v-if="calcDiscount(item) !== null" size="mini" type="danger" class="discount-tag">{{ calcDiscount(item) }}折</el-tag>
										<span class="vip-price" v-if="!isVipUser && item.vipPrice && item.vipPrice < item.curPrice">VIP ￥{{ item.vipPrice }}</span>
									</div>
								</div>
								<el-tooltip class="item" effect="dark" content="加入购物车" placement="bottom">
									<el-button type="primary" size="small" icon="el-icon-shopping-cart-2" class="btn-add" @click.stop="handleAddSingle(item, $event)"> </el-button>
								</el-tooltip>
							</div>

							<!-- 电子版商品 -->
							<div v-for="(item, idx) in info.digitStandardProduct || []" :key="'digit_' + info.id + '_' + idx" class="product-item">
								<div class="product-info">
									<div class="product-name">
										<el-tag size="mini" :type="item.hadBuy ? 'success' : 'warning'" effect="plain" class="product-type-tag">电子版{{ item.hadBuy ? ' · 已购' : '' }}</el-tag>
									</div>
									<div class="product-spu" v-if="item.prdSpuName" :title="item.prdSpuName">{{ formatProductName(item, info) }}</div>
									<div class="product-price">
										<span class="now-price">￥{{ displayPrice(item) }}</span>
										<span class="before-price" v-if="item.defaultPrice && displayPrice(item) < item.defaultPrice">￥{{ item.defaultPrice }}</span>
										<el-tag v-if="calcDiscount(item) !== null" size="mini" type="danger" class="discount-tag">{{ calcDiscount(item) }}折</el-tag>
										<span class="vip-price" v-if="!isVipUser && item.vipPrice && item.vipPrice < item.curPrice">VIP ￥{{ item.vipPrice }}</span>
									</div>
								</div>
								<el-tooltip class="item" effect="dark" content="加入购物车" placement="bottom">
									<el-button v-if="!item.hadBuy" type="primary" size="small" icon="el-icon-shopping-cart-2" class="btn-add" @click.stop="handleAddSingle(item, $event, 1)"> </el-button>
								</el-tooltip>
								<!-- <el-button v-if="!item.hadBuy" type="primary" size="small" icon="el-icon-shopping-cart-2" class="btn-add" @click.stop="handleAddSingle(item, $event, 1)"> </el-button> -->
								<div class="purchased-actions" v-if="item.hadBuy">
									<el-tooltip class="item" effect="dark" content="下载电子版" placement="bottom">
										<el-button class="btn-add" type="success" size="small" @click.stop="handleDownloadItem(info)"> <i class="el-icon-download"></i> </el-button>
									</el-tooltip>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pagebox mt10 mb10">
				<el-pagination
					:current-page.sync="pageNum"
					:page-size="pageSize"
					:page-sizes="[20, 30, 40, 50]"
					:total="totals"
					background
					layout="total, prev, pager, next"
					@size-change="handleSizeChange"
					@current-change="handleChangepage"
				>
				</el-pagination>
			</div>
		</div>
		<el-card v-else>
			<el-empty description="暂无数据" style="height: calc(100vh)"></el-empty>
		</el-card>

		<!-- <LoginBox ref="loginbox" @success="onLoginSuccess"></LoginBox> -->
		<DialogAddCart ref="dialogAddCart" />
		<!-- <BookBox ref="bookbox" :docmentid="cinfo.id"></BookBox> -->
	</section>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	// import LoginBox from '@/components/LoginBox/index.vue';
	import BookBox from '@/components/Book/BookBox.vue';
	import DialogAddCart from './DialogAddCart.vue';
	import TMessage from '@/utils/TMessage';
	import TMessageBox from '@/utils/TMessageBox';
	import { getReadCheck } from '@/api/standards/doc';
	import TLoading from '@/utils/TLoading.js';
	import User from '@/utils/User.js';
	import { getEnterpriseFileDownload } from '@/api/standards/es.js';

	export default {
		props: {
			dataList: {
				type: Array,
				default: []
			},
			totals: {
				type: Number,
				default: 0
			},
			pageNum: {
				type: Number,
				default: 1
			},
			pageSize: {
				type: Number,
				default: 20
			},
			searchValue: {
				type: String,
				default: ''
			},
			standardCode: {
				type: String,
				default: ''
			},
			standardName: {
				type: String,
				default: ''
			},
			showProduct: {
				type: Boolean,
				default: true
			},
			lifeList: {
				type: Array,
				default: () => []
			},
			standardTypeList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				loading: true,
				nextAct: '',
				// 加入购物车时使用
				// cinfo: {
				// 	id: '0'
				// },
				loadingInstance: null
			};
		},

		// 加载完执行
		created() {},
		methods: {
			...mapActions('Settings', ['setLoginShow']),

			// 格式化产品名称：避免重复拼接标准号
			// 1. 如果 prdSpuName 已包含 standardCode（原样），不拼接
			// 2. 如果包含'合订本'，不拼接
			// 3. 如果 prdSpuName 开头是 standardCode 去掉空格的版本（如 GB/T36668.5-2020游乐设施...），也不拼接
			formatProductName(item, info) {
				if (!item.prdSpuName) return item.prdSpuName;
				
				// 包含'合订本'不拼接
				if (item.prdSpuName.indexOf('合订本') !== -1) {
					return item.prdSpuName;
				}
				
				// 已包含标准号（原样）不拼接
				if (info.standardCode && item.prdSpuName.indexOf(info.standardCode) !== -1) {
					return item.prdSpuName;
				}
				
				// 标准号去空格后在名称开头，也不拼接
				// 例：prdSpuName="GB/T36668.5-2020游乐设施..." standardCode="GB/T 36668.5-2020"
				if (info.standardCode) {
					const codeWithoutSpace = info.standardCode.replace(/\s+/g, '');
					const nameStart = item.prdSpuName.substring(0, codeWithoutSpace.length).replace(/\s+/g, '');
					if (nameStart === codeWithoutSpace) {
						return item.prdSpuName;
					}
				}
				
				return info.standardCode ? info.standardCode + ' ' + item.prdSpuName : item.prdSpuName;
			},

			highlightText(text) {
				//修改：当匹配上queryInfo和standardCode时都显示高亮
				// 增强高亮功能，支持对queryInfo和standardCode的智能高亮

				if (!text) return text;

				//去掉 text 中的所有<br/>
				// text = text.replace(/<br\s*\/?>/g, '');

				// 获取所有需要高亮的关键词
				const keywords = [];
				if (this.searchValue) keywords.push(this.searchValue);
				if (this.standardCode) keywords.push(this.standardCode);
				if (this.standardName) keywords.push(this.standardName);

				if (keywords.length === 0) return text;

				const escapeRegExp = string => {
					return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
				};

				// 创建正则表达式，匹配所有关键词
				const escapedKeywords = keywords.map(keyword => escapeRegExp(keyword));
				const regexPattern = escapedKeywords.join('|');
				const regex = new RegExp(regexPattern, 'gi');

				// 同时高亮所有匹配的关键词
				return text.replace(regex, match => {
					return `<span style="color: #ff4d4f; font-weight: bold;">${match}</span>`;
				});
			},

			// 显示价格（VIP 优先）
			displayPrice(item) {
				
				if (!item) return 0;
				return this.isVipUser ? item.vipPrice : item.curPrice;
			},

			// 计算折扣
			calcDiscount(item) {
				const dp = this.displayPrice(item);
				const orig = item.defaultPrice;
				if (!dp || !orig || orig <= 0 || dp >= orig) return null;
				return ((dp / orig) * 10).toFixed(1);
			},

			// 单个商品直接加入购物车（isDigit: 0=纸质版 / 1=电子版）
			async handleAddSingle(item, event, isDigit) {
				if (!this.uisLogin) {
					this.setLoginShow(true);
					return;
				}
				if (!item || !item.prdSkuId) {
					TMessage.warning('商品信息异常');
					return;
				}
				// 【电子版去重】电子版商品不支持重复购买，如购物车中已存在同 skuId，直接提示，不走动画/接口
				if (isDigit === 1) {
					const cartList = (this.$store.getters && this.$store.getters['Cart/cartList']) || [];
					const exists = cartList.some(c => c && (c.skuId === item.prdSkuId || c.prdSkuId === item.prdSkuId));
					if (exists) {
						TMessage.warning('该电子版商品已在购物车中');
						return;
					}
				}
				// 先播抛物线动画，待小球砸入购物车并完成冲击反馈后，再发起接口请求
				await this.playCartParabola(event);
				try {
					await this.$store.dispatch('Cart/addCart', { goodList: [{ skuId: item.prdSkuId, buyNum: 1 }] }).then(() => {
						// 接口成功后再轻微抖一下，二次强化“已加入购物车”的反馈
						this.shakeCartButton();
					});
					// TMessageBox.confirm('恭喜！商品已加入购物车。', '提示', { confirmButtonText: '去结算' })
					// 	.then(() => {
					// 		this.$router.push({ path: '/index/Cart' });
					// 	})
					// 	.catch(() => {});
				} catch (e) {
					TMessage.error('添加失败，请稍后重试');
				}
			},

			// 加入购物车抛物线动画：从点击按钮飞入头部购物车，结束时带“砸入”冲击反馈
			playCartParabola(event) {
				return new Promise(resolve => {
					const btn = event && (event.currentTarget || event.target);
					if (!btn) {
						resolve();
						return;
					}
					const startRect = btn.getBoundingClientRect();
					const startX = startRect.left + startRect.width / 2;
					const startY = startRect.top + startRect.height / 2;

					// 终点：优先找 PageHeader 的购物车按钮，找不到回落到右上角
					const cartEl = document.querySelector('.btn-cart') || document.querySelector('.nav-btnbox .btn-cart') || document.querySelector('[data-cart-target]');
					let endX, endY;
					if (cartEl) {
						const r = cartEl.getBoundingClientRect();
						endX = r.left + r.width / 2;
						endY = r.top + r.height / 2;
					} else {
						endX = window.innerWidth - 80;
						endY = 40;
					}

					// 飞行的小球
					const ball = document.createElement('div');
					ball.innerHTML = '<i class="el-icon-shopping-cart-2"></i>';
					Object.assign(ball.style, {
						position: 'fixed',
						left: startX + 'px',
						top: startY + 'px',
						width: '34px',
						height: '34px',
						lineHeight: '34px',
						textAlign: 'center',
						borderRadius: '50%',
						background: 'linear-gradient(135deg, #f97316, #ef4444)',
						color: '#fff',
						fontSize: '18px',
						zIndex: 9999,
						pointerEvents: 'none',
						boxShadow: '0 6px 16px rgba(239,68,68,0.45)',
						transform: 'translate(-50%, -50%) scale(1)',
						willChange: 'left, top, transform, opacity'
					});
					document.body.appendChild(ball);

					// 加快速度：750ms -> 450ms
					const duration = 450;
					const startTime = performance.now();
					const dx = endX - startX;
					const dy = endY - startY;
					// 抛物线顶点高度（根据水平距离自适应）
					const peak = Math.min(Math.max(Math.abs(dx) * 0.35, 120), 260);

					const animate = now => {
						const t = Math.min((now - startTime) / duration, 1);
						// easeInCubic 让末端加速，更有“砸入”的冲击感
						const ease = t * t;
						const x = startX + dx * ease;
						const y = startY + dy * ease - 4 * peak * t * (1 - t);
						const scale = 1 - t * 0.4;
						ball.style.left = x + 'px';
						ball.style.top = y + 'px';
						ball.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
						if (t < 1) {
							requestAnimationFrame(animate);
						} else {
							// 【砸入冲击】小球瞬间扩张 + 透明消失，同时购物车按钮被“击中”压扁回弹
							ball.style.transition = 'transform 140ms ease-out, opacity 160ms ease-out';
							ball.style.transform = 'translate(-50%, -50%) scale(1.6)';
							ball.style.opacity = '0';
							setTimeout(() => ball.remove(), 200);

							if (cartEl && cartEl.animate) {
								cartEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.82)', offset: 0.35 }, { transform: 'scale(1.18)', offset: 0.7 }, { transform: 'scale(1)' }], {
									duration: 260,
									easing: 'cubic-bezier(.2,.8,.2,1.2)'
								});
							}
							// 冲击前摆（~180ms）后 resolve，再执行 dispatch
							setTimeout(resolve, 180);
						}
					};
					requestAnimationFrame(animate);
				});
			},

			// 购物车按钮抖动反馈：在 addCart 接口成功后触发
			shakeCartButton() {
				const cartEl = document.querySelector('.btn-cart') || document.querySelector('.nav-btnbox .btn-cart') || document.querySelector('[data-cart-target]');
				if (!cartEl || !cartEl.animate) return;
				cartEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(0.92)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'ease-out' });
			},

			handleInfo(info) {
				const { id, standardName, standardCode } = info;
				const targetRoute = this.$router.resolve({
					path: '/StandardsDet',
					query: { id}	
				});
				window.open(targetRoute.href, '_blank');
				// this.$router.push({ path: '/index/StandardsDet', query: { id } });
			},
			handleChangepage(val) {
				this.$emit('changepage', val);
			},
			handleSizeChange(val) {
				this.$emit('sizeChange', val);
			},

			// 已购电子版 - 下载
			async handleDownloadItem(item) {
				this.loadingInstance = TLoading.startBgWhite({ text: '文件准备中，请耐心等待 \n 若长时间未启动下载，请刷新页面后重试' });
				try {
					const response = await fetch(`/webL_api/consumer/order/downloadCorporateBook/${item.id}`, {
						method: 'get',
						headers: {
							Authorization: 'Bearer ' + User.getToken(),
							'corporate-id': User.getCorporate().corporateId,
							'Content-Type': 'application/json'
						}
					});

					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}

					const arrayBuffer = await response.arrayBuffer();
					const blob = new Blob([arrayBuffer], { type: 'zip' });

					// 创建下载链接而不是打开文件
					this.downloadFile(blob, item.standardName + '.zip');
				} catch (error) {
					TLoading.close(this.loadingInstance);
					console.error('下载文件失败:', error);
					this.$message.error('文件下载失败，请重试！');
				}
			},

			// 通用文件下载方法
			downloadFile(blob, filename) {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url); // 释放内存
				// 显示下载成功提示
				this.$message.success('文件下载成功！');
				TLoading.close(this.loadingInstance);
			},

			// 已购电子版 - 阅读
			handleReadItem(item) {
				if (!this.uisLogin) {
					this.setLoginShow(true);
					return;
				}
				if (!item) {
					TMessage.warning('商品信息异常');
					return;
				}
				const { id, standardCode, standardName, defaultPdf } = item;
				const targetRoute = this.$router.resolve({
					path: '/StandardsPdf',
					query: { id, code: standardCode, title: standardName, fileName: defaultPdf, docId: id }
				});
				window.open(targetRoute.href, '_blank');
			},

			// 设置加载中的状态
			setLoading(to) {
				this.loading = !!to;
			},

			// 登录后执行
			onLoginSuccess() {
				if (this.nextAct === 'openBookBox') {
					this.openBookBox();
				}

				this.nextAct = '';
			},

			// 加入书单
			openBookBox() {
				if (this.isLogin) {
					this.$refs.bookbox.open();
				} else {
					this.nextAct = 'openBookBox';
					this.$refs.loginbox.open();
				}
			},

			// 根据生命周期名称获取标签类型
			handleAddCart(info) {
				this.$refs.dialogAddCart.open(info.id);
			},

			handleSmartDoc(info) {
				if (!this.uisLogin) {
					this.setLoginShow(true);
					return;
				}
				getReadCheck(info.id).then(res => {
					if (res.code === 200) {
						const jsonRead = res.data.jsonRead;
						if (jsonRead) {
							const targetRoute = this.$router.resolve({
								path: '/StandardsDoc',
								query: { id: info.id, code: info.standardCode, title: info.standardName, docId: info.id }
							});
							window.open(targetRoute.href, '_blank');
						} else {
							const jsonReadVal = info.jsonRead;
							if (jsonReadVal == 1) {
								TMessage.warning('VIP文档，请升级后阅读，或购买后阅读！');
							} else if (jsonReadVal == 2) {
								TMessage.warning('请购买后阅读！');
							}
						}
					}
				});
			},

			getLifeName(lifeId) {
				if (!lifeId || !this.lifeList || !this.lifeList.length) return '';
				const found = this.lifeList.find(item => item.id === lifeId);
				return found ? found.lifeName : '';
			},
			
			getStandardTypeName(standardType) {
				if (standardType === undefined || standardType === null || !this.standardTypeList || !this.standardTypeList.length) return '';
				const found = this.standardTypeList.find(item => item.id === standardType);
				return found ? found.typeName : '';
			},
			
			getLifeTagType(lifeId) {
				if (!lifeId || !this.lifeList || !this.lifeList.length) return 'info';
				const found = this.lifeList.find(item => item.id === lifeId);
				if (!found) return 'info';
				const lifeNameLower = found.lifeName.toLowerCase();
			
				if (lifeNameLower.includes('现行') || lifeNameLower.includes('有效')) {
					return 'success'; // 绿色
				} else if (lifeNameLower.includes('征求意见稿') || lifeNameLower.includes('征求意见')) {
					return 'warning'; // 黄色
				} else if (lifeNameLower.includes('即将实施') || lifeNameLower.includes('即将生效')) {
					return 'primary'; // 蓝色
				}
				return 'danger'; // 红色
			},

			// 判断 PDF 文档阅读按钮是否显示
			canReadPdf(info) {
				if (!info || info.isPdf === 0) return false;
				// pdfRead: 0=公开, 1=VIP阅读, 2=购买后可阅读
				if (info.pdfRead == 0 || info.pdfRead == 1) return true;
				if (info.pdfRead == 2) {
					return (info.digitStandardProduct || []).some(item => item.hadBuy);
				}
				return false;
			}
		},
		computed: {
			...mapGetters('User', ['isLogin', 'uisLogin', 'uinfo']),
			// 判断是否为有效VIP用户（未登录返回false，已登录需levelId非0且levelEnd未过期）
			isVipUser() {
				if (!this.uisLogin || !this.uinfo) return false;
				const hasLevel = this.uinfo.levelId && this.uinfo.levelId !== 0;
				const now = new Date().getTime();
				const levelEndValid = this.uinfo.levelEnd && new Date(this.uinfo.levelEnd).getTime() > now;
				return hasLevel && levelEndValid;
			}
		},
		components: { BookBox, DialogAddCart }
	};
</script>

<style lang="less" scoped>
	// ========== 购物商品风格卡片 ==========
	.book-box {
		.infobox {
			position: relative;
			background-color: #ffffff;
			border-radius: 16px;
			margin-bottom: 14px;
			padding: 20px 24px;
			cursor: pointer;
			border: 1px solid #f1f5f9;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
			transition: all 0.25s ease;

			&:hover {
				border-color: #bfdbfe;
				box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
				transform: translateY(-2px);
			}
		}
		.el-card {
			border-radius: 16px;
			border: 1px solid #f1f5f9;
		}

		// 标签行
		.txtheader {
			display: flex;
			justify-content: space-between;
			margin-bottom: 10px;
			.star {
				color: #94a3b8;
				font-weight: 400;
			}
			.tags {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				gap: 6px;
				width: 100%;
				.tag-right {
					margin-left: auto;
				}
				/deep/ .el-tag {
					height: 22px !important;
					line-height: 22px !important;
					padding: 0 10px !important;
					font-size: 12px;
				}
			}
		}

		// 标题 - 商品主视觉
		.booktitle {
			font-size: 17px;
			font-weight: 700;
			color: #0f172a;
			line-height: 1.5;
			transition: color 0.2s ease;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}
		.infobox:hover .booktitle {
			color: #2563eb;
		}

		// 标题行 flex 布局：标题 + 查看详情按钮同行
		.title-row {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			gap: 12px;
			margin: 0;
			.booktitle-wrap {
				flex: 1;
				min-width: 0;
			}
			.el-button {
				flex-shrink: 0;
			}
		}

		// 内容区
		.txtbox {
			.contbox {
				display: flex;
				justify-content: space-between;
				align-items: stretch;
				gap: 24px;
				margin-top: 12px;

				// 描述文字
				.leftbox {
					font-size: 12px;
					flex: 1;
					min-width: 0;
					.textouter {
						font-weight: 400;
						font-size: 13px;
						color: #64748b;
						line-height: 1.7;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
					}
				}
			}

			// 商品区 - 最多2个商品
			.product-list {
				display: flex;
				flex-wrap: wrap;
				gap: 26px;
				flex-shrink: 0;
				margin-top: 18px;

				.product-item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: 20px;
					padding: 12px 14px;
					border: 1px solid #e2e8f0;
					border-radius: 10px;
					background: linear-gradient(135deg, #fafbff 0%, #f8fafc 100%);
					transition: all 0.2s ease;
					position: relative;

					&:hover {
						border-color: #bfdbfe;
						background: #ffffff;
						box-shadow: 0 3px 10px rgba(37, 99, 235, 0.1);
					}

					.product-info {
						flex: 1;
						min-width: 0;
						display: flex;
						flex-direction: column;
						gap: 10px;
					}

					.product-name {
						display: flex;
						align-items: center;
						gap: 6px;

						.product-type-tag {
							flex-shrink: 0;
							border-radius: 4px;
							height: 22px;
							line-height: 20px;
							padding: 0 8px;
							font-weight: 600;
						}
					}

					.product-spu {
						font-size: 14px;
						font-weight: 600;
						color: #1e293b;
						width: 235px;
						// max-width: 290px;
						// overflow: hidden;
						// text-overflow: ellipsis;
						// white-space: nowrap;
					}

					.product-price {
						display: flex;
						align-items: baseline;
						gap: 8px;
						flex-wrap: wrap;

						.now-price {
							font-size: 20px;
							font-weight: 800;
							color: #ef4444;
							line-height: 1;
							letter-spacing: -0.3px;
						}

						.before-price {
							font-size: 12px;
							color: #94a3b8;
							text-decoration: line-through;
						}

						.discount-tag {
							border: none;
							padding: 0 6px;
							height: 18px;
							line-height: 18px;
							font-weight: 600;
							border-radius: 4px;
						}

						.vip-price {
							font-size: 12px;
							color: #b45309;
							font-weight: 600;
							background: linear-gradient(135deg, #fef3c7, #fde68a);
							padding: 2px 8px;
							border-radius: 10px;
						}
					}

					.btn-add {
						flex-shrink: 0;
						// align-self: flex-start;
						padding: 8px 14px;
						font-size: 13px;
						font-weight: 600;
						border-radius: 8px;
						// background: linear-gradient(135deg, #2563eb, #1d4ed8);
						border: none;
						box-shadow: 0 2px 6px rgba(37, 99, 235, 0.25);
						transition: all 0.2s ease;

						&:hover {
							box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
							transform: translateY(-1px);
						}

						&:active {
							transform: translateY(0);
						}
					}
				}
			}
		}

		// 按钮区
		.actionbox {
			.el-button {
				font-weight: 600;
				font-size: 14px;
				padding: 10px 24px;
				border-radius: 10px;
			}
		}

		.mt10 {
			margin-top: 16px;
		}
		.mr10 {
			margin-right: 10px;
		}
		.mb10 {
			margin-bottom: 16px;
		}
		.mt34 {
			margin-top: 34px;
		}
	}

	.rightbox {
		display: flex;
		flex-direction: column;
		gap: 10px;
		flex-shrink: 0;
		align-items: stretch;
		justify-content: flex-start;
		margin-left: 24px;

		.el-button {
			font-weight: 600;
			font-size: 13px;
			padding: 8px 18px;
		}
	}

	// 响应式 - 中屏将商品区收窄
	@media screen and (min-width: 768px) and (max-width: 1280px) {
		.book-box {
			.txtbox .contbox .rightbox {
				// width: 340px;
			}
		}
	}

	// 小屏商品竖排
	@media screen and (max-width: 1199px) {
		.product-list {
			flex-direction: column;
		}
	}

	// 小屏垂直展示
	@media screen and (max-width: 767px) {
		.book-box {
			.txtbox .contbox {
				flex-direction: column;
				gap: 12px;
				.rightbox {
					min-width: 0;
					margin-left: 0;
					flex-direction: row;
				}
				.leftbox {
					margin-right: 0;
				}
			}
		}
	}

	.purchased-actions {
		display: flex;
		//gap: 10px;
		//.btn-download-item,
		//.btn-read-item {
		//	display: flex;
		//	align-items: center;
		//	gap: 4px;
		//	padding: 6px 16px;
		//	border-radius: 6px;
		//	font-size: 13px;
		//	font-weight: 500;
		//	border: 1px solid;
		//	cursor: pointer;
		//	transition: all 0.2s ease;
		//	i {
		//		font-size: 14px;
		//	}
		//}
		//.btn-download-item {
		//	color: #2563eb;
		//	border-color: #bfdbfe;
		//	background: #eff6ff;
		//	&:hover {
		//		background: #2563eb;
		//		color: #fff;
		//		border-color: #2563eb;
		//	}
		//}
		//.btn-read-item {
		//	color: #059669;
		//	border-color: #a7f3d0;
		//	background: #ecfdf5;
		//	margin-left: 12px;
		//	&:hover {
		//		background: #059669;
		//		color: #fff;
		//		border-color: #059669;
		//	}
		//}
	}

	::v-deep .product-list .el-divider--horizontal {
		margin: 0 auto !important;
	}

	::v-deep .product-list .el-divider__text {
		font-size: 15px !important;
		font-weight: 600 !important;
		color: #333 !important;
	}
</style>
